module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1005-a39c70b499b33649ec68a458f5555e50.png";